/**
 * Hands the buyer's checkout details to the AiSensy signup script on the
 * thank-you page, which reads this cookie and pre-fills its form.
 *
 * Host-only (no Domain), so the details stay on the checkout host and are not
 * sent to other *.aisensy.com services. Expires in 30 minutes; the script
 * deletes it after a successful signup. Never put these in the URL: the
 * thank-you page runs ad pixels that receive the full page URL.
 */
const SIGNUP_PREFILL_COOKIE = "as_signup_prefill";
const SIGNUP_PREFILL_MAX_AGE = 30 * 60;

/** Save { fullName, email, phone, countryCode, company }. Never throws. */
export function saveSignupPrefill(fields) {
  try {
    const clean = {};
    Object.keys(fields || {}).forEach((key) => {
      const value = fields[key];
      if (typeof value === "string" && value.trim()) clean[key] = value.trim();
    });
    if (Object.keys(clean).length === 0) return;
    document.cookie =
      `${SIGNUP_PREFILL_COOKIE}=${encodeURIComponent(JSON.stringify(clean))}` +
      `; Max-Age=${SIGNUP_PREFILL_MAX_AGE}; path=/; Secure; SameSite=Lax`;
  } catch (e) {
    // non-fatal: the form just starts empty
  }
}
